import React from "react";
var EmptyTemplate = function () { return null; };
export default React.createContext({
    subTemplate: EmptyTemplate,
    getSubTemplate: function (arg1, arg2) { return EmptyTemplate; }
});
